import React, { useContext } from 'react';
import {Button, IconButton, Menu, MenuItem, useTheme} from "@mui/material";
import { Language, ArrowDropDown } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { useChangeLanguage } from '../hooks';
import { ApiContext } from '../context/Api';

export default function LanguageSelect({ showLanguage, variant }) {
  const theme = useTheme();
  const { locales } = useContext(ApiContext);
  const { t, i18n } = useTranslation();
  const changeLanguage = useChangeLanguage();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggle = showLanguage
    ? (
      <Button
        id="language-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        variant={variant || 'contained'}
        color="dark"
        startIcon={<Language />}
        endIcon={<ArrowDropDown />}
      >{t('currentLanguage')}</Button>
    )
    : (
      <IconButton
        id="language-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        sx={{color: theme.palette.primary.contrastText}}
      >
        <Language />
      </IconButton>
    );

  const isActive = lng => lng === i18n.language;
  const onSelect = key => {
    changeLanguage(key);
    setAnchorEl(null);
  };

  const items = (locales || [])
    .filter(x => x.published)
    .map(locale => (
      <MenuItem
        key={locale.code}
        onClick={() => onSelect(locale.code)}
        disabled={isActive(locale.code)}
      >
        {locale.localName}
      </MenuItem>
    ));
  return (
    <div>
      {toggle}
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'language-button',
          },
        }}
      >

        {items}
      </Menu>
    </div>
  );
}
